import Swiper from 'swiper/bundle';
import { smootherPause } from './smoother';

export const foodBowlSlider = () => {
    const select = document.querySelectorAll('.food-bowl-slider');
    select.forEach(e => {
        let sliderArr = [];
        const productSliderTexts = e.querySelector('.food-bowl-slider__texts');
        const sliderTexts = productSliderTexts.querySelectorAll('.food-bowl-slider__texts > *');
    
        const resize = () => {
            sliderArr = [];
            sliderTexts.forEach(e => {
                sliderArr.push(e.clientHeight);
            })

            productSliderTexts.style.height = `${Math.max.apply(null, sliderArr)/10}rem`;
        }
    
        var swiper = new Swiper(e.querySelector(".food-bowl-slider__swiper"), {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            preloadImages: false,
            lazy: true,
            pagination: {
                el: e.querySelector(".food-bowl-slider__swiper-pagination.swiper-pagination"),
                clickable: true,
                renderBullet: function (index, className) {
                  return `<div class="${className}"><p class="p1 d-inline-block mb-0">${index + 1}</p></div>`;
                },
            },
            on: {
                slideChangeTransitionStart: () => {
                    sliderTexts.forEach(e => e.classList.remove('active'));
                    setTimeout(() => {
                        sliderTexts[swiper.realIndex].classList.add('active');
                    }, 300)
                },
                sliderMove: () => {
                    smootherPause(true);
                },
                touchEnd: () => {
                    smootherPause(false);
                }
            }
        });

        sliderTexts.forEach(e => {
            sliderArr.push(e.clientHeight);
        })
    
        resize();
        window.addEventListener('resize', ()=> {
            resize();
        })
    })
}
